import { z } from '@foxtail-dev/datacontracts'

export const ROWS_PER_PAGE = ['25', '50', '100'] as const

export const RowsPerPage = z.enum(ROWS_PER_PAGE)
export type RowsPerPage = z.infer<typeof RowsPerPage>
